export default "__VITE_ASSET__DQ7iV_1k__"